import React from 'react';

import Title from '../../components/Title';
import Spreader from '../../components/Spreader';
import Paragraph from '../../components/Paragraph';
import Quote from '../../components/Quote';
import Sticker from '../../components/Sticker';
import Menu from '../../components/Menu';
import Grid from '../../components/Grid';
import Banner from '../../components/Banner';
import Mention from '../../components/Mention';
import Scalable from '../../components/Scalable';
import CallToAction from '../../components/CallToAction';

import { StickyContainer } from 'react-sticky';

const GeniousPage = props => (
  <StickyContainer>
    <Menu active="architecture2" />
    <Spreader>
      <Title text="Гений места" />
      <Paragraph>
        Как&nbsp;бы ни&nbsp;ругали экономическое положение граждан
        и&nbsp;современное состояние рынка недвижимости, эксперты, безусловно,
        сходятся в&nbsp;одном: покупатель недвижимости любого класса остается
        в&nbsp;выигрыше. Рынок покупателя стимулирует застройщиков делать
        продукт, отличающийся от&nbsp;конкурентов: лучше, элегантнее,
        продуманнее и&nbsp;удобнее для клиентов. И&nbsp;чем дальше, тем больше
        шансов найти жилой комплекс с&nbsp;опциями, характерными для предложения
        более высокого класса. Предложения комфорт-класса получают черты
        комплексов бизнес-класса, бизнес стремится к&nbsp;премиуму, получает
        ранее недоступные в&nbsp;этом классе опции в&nbsp;отделке общественных
        зон, квартирографии, дизайне дворовых территорий, инфраструктурных
        решениях.
      </Paragraph>
    </Spreader>
    <Spreader>
      Надо сказать, что рынок довольно жестко стоит на&nbsp;своем: элитный
      статус определяется местом и&nbsp;только им.&nbsp;Это одна, если
      не&nbsp;самая важная, из&nbsp;причин, по&nbsp;которой девелоперы выводят
      на&nbsp;рынок премиальные и&nbsp;элитные по&nbsp;качеству объекты под
      маркой бизнес-класса. Этой возможностью, свидетельствует статистика,
      с&nbsp;удовольствием пользуются покупатели, для которых элитный статус
      района не&nbsp;является приоритетом при выборе жилья. Более того, для
      многих важным является возможность поселиться в&nbsp;хорошем, месте,
      но&nbsp;не&nbsp;в&nbsp;центре, просто потому, что люди привыкли
      к&nbsp;району, их&nbsp;с&nbsp;ним многое связывает, там живут родители,
      есть хорошие школы, много зелени и&nbsp;нет суеты, так мешающей
      размеренной жизни в&nbsp;пределах Садового кольца. При этом качество дома
      имеет для них решающее значение, как и&nbsp;то, что их&nbsp;дом является
      самым интересным, красивым и&nbsp;&laquo;важным&raquo; в&nbsp;ближайшем
      окружении. Примерами такого подхода могут служить проекты бизнес-класса
      компании &laquo;Галс-Девелопмент&raquo;. Четыре из&nbsp;них, находящиеся
      на&nbsp;стадии строительства, наглядно показывают: такие комплексы могут
      формировать новую элитную историю места.
    </Spreader>
    <Spreader>
      Каждый из&nbsp;них обладает всеми чертами премиальных проектов:
      продуманное архитектурное решение, парадные фасады, привлекающие внимание
      и&nbsp;повышающие ценность района. Надо отметить, что районы для
      строительства проектов выбирались тщательно. Во&nbsp;главу угла ставилась
      их&nbsp;перспективность по&nbsp;дальнейшему повышению статуса места,
      драйвером для которого должны послужить комплексы{' '}
      <a
        href="https://hals-development.ru/?utm_source=kommersant&utm_medium=Cpec_project&utm_campaign=hals"
        target="_blank"
      >
        &laquo;Галс-Девелопмент&raquo;
      </a>
      .
    </Spreader>

    <Spreader isDisappear style={{ marginBottom: '40px' }}>
      <Scalable style={{ marginBottom: '1.5%' }}>
        <img width="100%" src={'images/media/grid_2_1.jpg'} />
      </Scalable>
      <Grid
        fullWidth={3}
        blocks={[
          {
            width: 2,
            content: (
              <Scalable>
                <img src="images/media/grid_2_2.jpg" width="100%" />
              </Scalable>
            ),
          },
          {
            width: 1,
            content: (
              <Scalable
                style={{ marginBottom: '5%', marginLeft: '5%', width: '95%' }}
              >
                <img src="images/media/grid_2_3.jpg" width="100%" />
              </Scalable>
            ),
          },
          {
            width: 1,
            content: (
              <Scalable style={{ marginLeft: '5%' }}>
                <img src="images/media/grid_2_4.jpg" width="100%" />
              </Scalable>
            ),
          },
        ]}
      />
      <Mention>
        На фото: Квартал{' '}
        <a
          href="https://iskra-park.ru/?utm_source=kommersant&utm_medium=Cpec_project&utm_campaign=hals"
          target="_blank"
        >
          «Искра-Парк»
        </a>
      </Mention>
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      Первая премиальная черта проекта бизнес-класса{' '}
      <a
        href="https://matchpointhouse.ru/?utm_source=kommersant&utm_medium=Cpec_project&utm_campaign=hals"
        target="_blank"
      >
        Match Point
      </a>
      , который &laquo;Галс-Девелопмент&raquo; взяла в&nbsp;управление
      в&nbsp;качестве fee-девелопера,&nbsp;&mdash; местоположение
      в&nbsp;непосредственной близости от&nbsp;&laquo;парадного&raquo;
      Кутузовского проспекта, &laquo;Москва-Сити&raquo;, Парка Победы
      на&nbsp;Поклонной горе, зеленых массивов Филевского парка. Из&nbsp;окон
      всех фасадов комплекса открываются шикарные виды на&nbsp;город
      во&nbsp;всей его красе. Не&nbsp;подвело и&nbsp;качество самого проекта,
      в&nbsp;составе которого есть спортивная волейбольная арена общей площадью
      23 тыс. кв. м. По&nbsp;окончании строительства арена, рассчитанная
      на&nbsp;3500 зрителей, станет новой тренировочной базой для спортивного
      общества &laquo;Динамо&raquo;. Жилая часть также вполне соответствует
      премиальному статусу: большая парковка для жителей, качественная отделка
      общественных зон, богатое инфраструктурное наполнение и, конечно, закрытый
      для посторонних двор с&nbsp;ландшафтным дизайном и&nbsp;модными
      общественными зонами, где можно вместе с&nbsp;соседями провести время,
      погулять с&nbsp;детьми.
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      Самый ближний к&nbsp;центру &laquo;премиальный
      бизнес-класс&raquo;&nbsp;&mdash; городской квартал
      &laquo;Искра-Парк&raquo;, спроектированный мастерской SPEECH при участии
      &laquo;Студии Артемия Лебедева&raquo;, которая разработала для фасадов
      комплекса уникальный рисунок-паттерн с&nbsp;изображением великих
      достижений науки и&nbsp;искусства середины XX&nbsp;века. Объект возводится
      в&nbsp;концепции &laquo;город в&nbsp;городе&raquo;&nbsp;&mdash; жители
      апартаментов будут располагать собственной подземной парковкой
      и&nbsp;благоустроенным закрытым двором с&nbsp;детскими площадками
      и&nbsp;прогулочными дорожками, который еще недавно считался сугубо
      премиальной опцией. Особого внимания заслуживает атмосфера собственного
      респектабельного квартала, своего &laquo;комьюнити&raquo;: когда,
      спустившись вниз, на&nbsp;первом этаже комплекса можно зайти
      в&nbsp;хороший винный бар, не&nbsp;выходя за&nbsp;пределы квартала, зайти
      во&nbsp;фреш-маркет, посидеть в&nbsp;кофейне. И&nbsp;без того неплохой
      район постепенно расцветает, и&nbsp;уже сложно говорить о&nbsp;его
      &laquo;непремиальности&raquo;. Через дорогу разбит новый парк
      на&nbsp;Ходынском поле, напротив&nbsp;&mdash; старый Петровский парк
      с&nbsp;новым стадионом &laquo;Динамо&raquo;. Ледовый дворец
      &laquo;Мегаспорт&raquo;, стадион &laquo;ЦСКА&raquo;, бассейн&nbsp;&mdash;
      все условия для занятий спортом для всех членов семьи.
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      Соцопросы показывают, что недовольных районом Ходынского поля жителей
      почти нет. И&nbsp;это не&nbsp;удивительно: социальный состав населения
      не&nbsp;только современной застройки Ходынского поля,
      но&nbsp;и&nbsp;прилегающих более старых районов однороден&nbsp;&mdash;
      здесь издавна живет творческая интеллигенция, научные работники,
      спортсмены. Традиции &laquo;хорошего района&raquo; передаются
      и&nbsp;детям: хорошие школы, как общеобразовательные, так
      и&nbsp;спортивные, здесь были всегда. И&nbsp;сегодня спорт здесь
      на&nbsp;высоте: и&nbsp;любительский, и&nbsp;профессиональный. Главное
      не&nbsp;лениться, проявлять упорство и&nbsp;брать пример с&nbsp;именитых
      соседей.
    </Spreader>
    <Spreader isDisappear style={{ marginBottom: '40px' }}>
      <Scalable>
        <Banner
          text="За детальной информацией переходите на сайт  hals&#8209;development.ru"
          linkTitle="Перейти на сайт сейчас"
          link="https://hals-development.ru/?utm_source=kommersant&utm_medium=Cpec_project&utm_campaign=hals"
          bannerBackground="images/banner-bg.png"
        />
      </Scalable>
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      Проекты уникального для места архитектурного решения могут помочь изменить
      и&nbsp;имидж территории. Так, район Преображенской площади
      с&nbsp;появлением проекта &laquo;Наследие&raquo; сменил строку негласного
      городского рейтинга на&nbsp;&laquo;Бизнес+&raquo;. К&nbsp;слову, район
      недооценен с&nbsp;точки зрения строительства дорогого жилья&nbsp;&mdash;
      недалеко от&nbsp;центра, рядом парк &laquo;Сокольники&raquo;, река Яуза.
      Преображенка&nbsp;&mdash; старый район со&nbsp;своими традициями,
      легендами, &laquo;тайными местами&raquo;, известными только местным
      жителям и&nbsp;москвоведам, с&nbsp;удовольствием рассказывающим
      о&nbsp;&laquo;старых временах&raquo;, в&nbsp;которых район сыграл важную
      роль. Сегодняшние жители районом тоже гордятся, переезжать отсюда
      не&nbsp;любят. Поэтому к&nbsp;появлению нового красивого проекта отнеслись
      благосклонно. &laquo;Наследие&raquo;&nbsp;&mdash; один из&nbsp;самых
      удачных проектов &laquo;Галс-Девелопмент&raquo;, где продажи завершились
      быстрее, чем строительство дома, и, как свидетельствует статистика продаж,
      немало квартир в&nbsp;комплексе приобретено именно жителями окрестных
      районов. &laquo;Популярность комплекса обусловлена выбором классического
      архитектурного стиля, продуманной квартирографией и&nbsp;инфраструктурной
      составляющей&raquo;,&nbsp;&mdash; считает старший вице-президент
      &laquo;Галс-Девелопмент&raquo; Леонид Капров. И&nbsp;не&nbsp;ошибается:
      до&nbsp;&laquo;Наследия&raquo; домов с&nbsp;таким разнообразием планировок
      в&nbsp;окрестностях просто не&nbsp;было. В&nbsp;первой очереди покупателям
      предлагались квартиры с&nbsp;элементами загородного жилья&nbsp;&mdash;
      террасами и&nbsp;отдельным входом на&nbsp;первых этажах: воспоминание
      о&nbsp;старой Москве с&nbsp;ее&nbsp;уютными усадьбами, садами
      и&nbsp;летними чаепитиями на&nbsp;дачах, ведь Сокольники&nbsp;&mdash;
      известное дачное место. Во&nbsp;всех трех очередях есть квартиры
      с&nbsp;панорамными окнами и&nbsp;дымоходами для установки&nbsp;дровяного
      камина на&nbsp;последних этажах. Премиальной являются отделка
      и&nbsp;наполнение входных групп: колясочные, кладовые, вместительный
      паркинг с&nbsp;коэффициентом почти два машино-места
      на&nbsp;квартиру&nbsp;&mdash; цифра, присущая комплексам более высокого
      класса. Статус подчеркивают дорогая отделка входных групп, лифты OTIS,
      закрытый двор с&nbsp;ландшафтным дизайном и&nbsp;детскими
      площадками&nbsp;&mdash; важный элемент, так как комплекс в&nbsp;первую
      очередь ориентирован на&nbsp;проживание семей с&nbsp;детьми. Для них
      на&nbsp;территории ЖК&nbsp;также построен современный детский сад.
      Взрослые тоже получили хорошую инфраструктуру: кафе, рестораны, службы
      быта и&nbsp;другие нужные сервисы в&nbsp;составе двух небольших торговых
      центров, которые уже открылись и&nbsp;успешно функционируют для жителей
      комплекса и&nbsp;всего района.
    </Spreader>
    <Spreader isDisappear>
      <Scalable style={{ marginBottom: '1.5%' }}>
        <img width="100%" src={'images/media/grid_2_3_1.jpg'} />
      </Scalable>
    </Spreader>
    <Spreader isWide>
      <Sticker>
        <Quote
          author={{
            photo: 'images/media/kaprov.jpg',
            position: 'старший вице-президент ',
            positionLink: '«Галс-Девелопмент»',
            fullName: 'Леонид Капров',
          }}
          text="Популярность комплекса обусловлена выбором классического архитектурного стиля, продуманной квартирографией и инфраструктурной составляющей"
        />
      </Sticker>
    </Spreader>
    <Spreader isDisappear style={{ marginBottom: '40px' }}>
      <Grid
        fullWidth={3}
        blocks={[
          {
            width: 2,
            content: (
              <Scalable>
                <img src="images/media/grid_2_2_2.jpg" width="100%" />
              </Scalable>
            ),
          },
          {
            width: 1,
            content: (
              <Scalable
                style={{ marginBottom: '5%', marginLeft: '5%', width: '95%' }}
              >
                <img src="images/media/grid_2_2_3.jpg" width="100%" />
              </Scalable>
            ),
          },
          {
            width: 1,
            content: (
              <Scalable style={{ marginLeft: '5%' }}>
                <img src="images/media/grid_2_2_4.jpg" width="100%" />
              </Scalable>
            ),
          },
        ]}
      />
      <Mention>
        На фото: Квартал{' '}
        <a
          href="https://matchpointhouse.ru/?utm_source=kommersant&utm_medium=Cpec_project&utm_campaign=hals"
          target="_blank"
        >
          «Матч Поинт»
        </a>
      </Mention>
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      Жилой комплекс &laquo;Наследие&raquo; назван одним из&nbsp;лучших
      строительных объектов Москвы по&nbsp;результатам конкурса &laquo;Лучший
      объект строительства&raquo;, организованного Комитетом государственного
      строительного надзора Москвы, что подчеркивает его ценность для района
      и&nbsp;города.
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      Премиальным качеством обладает и&nbsp;проект &laquo;Достояние&raquo;,
      строящийся в&nbsp;районе Кунцево. Три башни комплекса получили названия
      &laquo;Наука&raquo;, &laquo;Культура&raquo;
      и&nbsp;&laquo;Искусство&raquo;. Здесь тоже не&nbsp;обошлось без
      премиального подхода. Входные группы корпусов &laquo;Наука&raquo;,
      &laquo;Культура&raquo; и&nbsp;&laquo;Искусство&raquo; украсили шесть
      художественных панно из&nbsp;смальтовой мозаики с&nbsp;изображением ярких
      культурных символов и&nbsp;великих деятелей прошлого века. Мозаичные панно
      выполнены вручную. &laquo;Повышенный&raquo; статус дома вновь подчеркивает
      наполнение. Особенность проекта&nbsp;&mdash; уникальная квартирограмма,
      сегмент которой меняется каждые три этажа. На&nbsp;верхних этажах
      расположено 6 панорамных пентхаусов с&nbsp;открытыми террасами
      и&nbsp;возможностью установки каминов. Не&nbsp;забыты
      и&nbsp;автомобилисты: число машино-мест на&nbsp;двухуровневой подземной
      парковке комплекса рассчитано с&nbsp;коэффициентом более чем 1
      на&nbsp;квартиру&nbsp;&mdash; редко встречающаяся опция. Название{' '}
      <a
        href="https://dostoyanie-hals.ru?utm_source=kommersant&utm_medium=Cpec_project&utm_campaign=hals"
        target="_blank"
      >
        ЖК&nbsp;&laquo;Достояние&raquo;
      </a>
      &nbsp;&mdash; дань престижному району: через дорогу&nbsp;&mdash;
      Крылатское, неподалеку расположены учебные и&nbsp;научные заведения,
      а&nbsp;главное&nbsp;&mdash; школы, ради которых сюда возят детей
      из&nbsp;других районов. Так что у&nbsp;юных жителей комплекса будут все
      возможности стать интеллектуальной или бизнес-элитой страны, не&nbsp;тратя
      лишнего времени на&nbsp;дорогу до&nbsp;школы или выбранного вуза.
      За&nbsp;последние годы к&nbsp;научной репутации района добавилась
      и&nbsp;бизнес-репутация&nbsp;&mdash; в&nbsp;крупных офисных центрах
      неподалеку разместились головные офисы крупных компаний, так что взрослым
      жителям комплекса будет не&nbsp;менее удобно добираться до&nbsp;работы,
      как и&nbsp;привыкли москвичи, живущие в&nbsp;домах настоящей Москвы.
    </Spreader>
  </StickyContainer>
);

export default GeniousPage;
//<CallToAction />
